export default __webpack_public_path__ + "static/media/gorra.7fbcee1f.png";